import API from '../../../api/endpoints.js'
import Vue from 'vue'

export default {
  getEntityById (entity, id) {
    return Vue.http.get(API.GET_ADMIN_ENTITY_BY_ID(entity, id), { headers: { 'X-Lazy-Fetch': '0' } })
  },
  massTariffStatusUpdate (body) {
    return Vue.http.put(API.MASS_TARIFF_REQUEST_STATUS, body)
  },
  cloneTariff (id) {
    return Vue.http.post(API.CLONE_TARIFF(id), {})
  },
  getEntities (entity, json, opts = { 'X-Lazy-Fetch': '0' }) {
    return Vue.http.get(API.GET_ENTITIES(entity), { params: json, headers: { ...opts } })
  },
  getEntitiesCount (entity, json) {
    return Vue.http.get(API.GET_ENTITIES(entity), { params: json, headers: { 'X-Count-Fetch': 'true' } })
  },
  saveEntity (entity, json) {
    return json.hasOwnProperty('id') && json.id ? Vue.http.put(API.UPDATE_ADMIN_ENTITY(entity, json.id), json) : Vue.http.post(API.CREATE_ADMIN_ENTITY(entity), json)
  },
  deleteEntity (entity, id) {
    return Vue.http.delete(API.DELETE_ADMIN_ENTITY(entity, id))
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/store/service.js